// extracted by mini-css-extract-plugin
module.exports = {"AADS":"DeltaAdvPC_AADS__dZiIR"};